export default {
  user: {
    data: {
      'id': 1,
      'username': 'Bagouze',
      'first_name': '',
      'last_name': '',
      'is_superuser': true
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/test-api/datas/user.data.js